import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Lookup,
    Summary,
    TotalItem,
} from "devextreme-react/data-grid";
import { HeaderLayout, SearchLayout } from './Layout';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { LoadPanel, TextBox } from 'devextreme-react';
import axios from 'axios';
import data from '../../../assets/apiRoutes.json'
import notify from 'devextreme/ui/notify';
import { MESSAGES } from '../../../common/Messages';
import { alert, confirm } from 'devextreme/ui/dialog';
import { OM } from '../../../const/constants';
import { TransactionTypes } from '../../../enum/Enum';
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const From = (props) => {
    const history = useHistory();
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var accessToken = props.oidc.user.access_token;
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const rowId = useRef(null);
    const dataGrid = useRef(null);
    const [resultData, setResultData] = useState(null);
    const gridKey = "5BAA61C5-5895-465A-90EC-AA9A621113E1";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const formRefs = useRef({});
    const initialFormFields = {
        FMTRIPNUMBER: "",
        R_TRUCK: null,
        TRUCKARRIVALDATETIME: null,
        R_DRIVER: null,
        R_TRAILER: null,
        R_FMSHIPPER: null,
        R_SHIPVIA: null,
        ROWID: "",
        TRANSACTIONNUMBER: "",
        SHIPPINGDATE: null,
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].ROWID;
        }
        else {
            rowId.current = '';
        }
        setIsEditButtonDisabled(!isEditButtonDisabled);
    };
    useEffect(() => {
        if (props.id) {
            LoadData();
        }
    }, [props.id]);
    const LoadData = async () => {
        const result = await loadDatasource(`?TripNumber=${props.id}`);
        if (result.data && result.data.length > 0) {
            setResultData(result.data);
            let data = result.data[0];
            setformFields(prevState => ({
                ...prevState,
                FMTRIPNUMBER: data.FMTRIPNUMBER,
                R_TRUCK: data.R_TRUCK,
                TRUCKARRIVALDATETIME: data.TRUCKARRIVALDATETIME,
                TRUCKDEPARTDATETIME: data.TRUCKDEPARTDATETIME,
                R_DRIVER: data.R_DRIVER,
                R_TRAILER: data.R_TRAILER,
                SHIPPINGDATE: data.SHIPPINGDATE,
                R_FMSHIPPER: data.R_FMSHIPPER,
                R_SHIPVIA: data.R_SHIPVIA,

            }));
        }
    };
    const loadDatasource = async (params) => {
        setLoadPanelVisible(true);
        const res = await axios.get(`${window._env_.REACT_APP_APIS}/${data.OM.GetTripTransactions}${params}`,
            {
                params: params,
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                }
            }).finally(() => {
                setLoadPanelVisible(false);
            });
        return res;
    }
    const handleFieldChange = (() => {
        let lastCall = { name: null, value: null };
        return (name, value, e) => {
            if (name === "ROWID" && !(lastCall.name === name && lastCall.value === value)) {
                addNewRow(value);
            }
            lastCall = { name, value };
        };
    })();
    const handleSelectedItemChange = (name, e) => {

    }
    const handleFormLoad = () => {

    }
    const updatedRecords = (data) => {
        data.forEach(record => {
                record.FMTRIPNUMBER = formFields.FMTRIPNUMBER;
                record.R_TRUCK = formFields.R_TRUCK;
                record.TRUCKARRIVALDATETIME = formFields.TRUCKARRIVALDATETIME;
                record.TRUCKDEPARTDATETIME = formFields.TRUCKDEPARTDATETIME;
                record.R_DRIVER = formFields.R_DRIVER;
                record.R_TRAILER = formFields.R_TRAILER;
                record.SHIPPINGDATE = formFields.SHIPPINGDATE;
                record.R_FMSHIPPER = formFields.R_FMSHIPPER;
                record.R_SHIPVIA = formFields.R_SHIPVIA;
        });
        return data;
    }
    const handleSubmit = () => {
        if (!resultData || resultData.length == 0) return;
        let dataToUpdate = [];
        if (resultData && resultData.length > 0) {
            const updatedData = updatedRecords([...resultData]);
            dataToUpdate = [...updatedData];
        }
        updateData(dataToUpdate, MESSAGES.UPDATE_SUCCESS);
    };
    const updateData = (dataToUpdate, message) => {
        setLoadPanelVisible(true);
        axios.put(`${window._env_.REACT_APP_APIS}/${data.OM.BatchUpdateTransactionHeader}`,
            dataToUpdate,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                }
            })
            .then((result) => {
                if (result.status == 200) {
                    notify(message, 'success', 3000);
                }
                else {
                    alert(result.data.message, MESSAGES.ERROR);
                }
            }).finally(() => {
                setLoadPanelVisible(false);
            });
    }
    const getNextTransNumber = async () => {
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/${data.AB.GetTransactionNo}`,
                {
                    params: {
                        Module: OM,
                        TransactionType: TransactionTypes.FMTripNumber,
                    },
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error(MESSAGES.FETCH_ERROR, error);
            throw error;
        }
    };
    const handleReset = () => {
        LoadData();
    }
    const handleAddNew = async () => {
        let fields = { ...initialFormFields };
        fields.FMTRIPNUMBER = await getNextTransNumber();
        setformFields(fields);
        setResultData([]);
    }

    const addNewRow = async (rowid) => {
        if (!rowid) return;
        const rowToAdd = await loadDatasource(`?Rowid=${rowid}`);
        if (rowToAdd.data && rowToAdd.data.length > 0) {
            const newRow = rowToAdd.data[0];

            setResultData(prevData => {
                if (!prevData || prevData.length === 0) {
                    // If no existing data, return array with the new row
                    return [newRow];
                }

                // Check for duplicate before adding (using latest state)
                const isDuplicate = prevData.some(row => row.ROWID === newRow.ROWID);
                if (isDuplicate) {
                    notify({ message: MESSAGES.TRANSACTION_ALREADY_IN_LIST, width: 450 }, 'warning', 3000);
                    return prevData;
                }

                // Append single row at the end of existing data
                return [...prevData, newRow];
            });
        }
    }
    const handleDelete =async () => {
        if (!rowId.current) return;
        const confirmDelete =await confirm(MESSAGES.DELETE_CONFIRM, "Delete");
        if (!confirmDelete) return;
        // Get the row data before removing it
        const rowToDelete = resultData?.find(row => row.ROWID === rowId.current);

        // Remove row from resultData
        setResultData(prevData => {
            if (!prevData) return prevData;
            return prevData.filter(row => row.ROWID !== rowId.current);
        });

        // Track the deleted row ID
        if (rowToDelete) {
            rowToDelete.FMTRIPNUMBER = null;
            rowToDelete.R_TRUCK = null;
            rowToDelete.TRUCKARRIVALDATETIME = null;
            rowToDelete.TRUCKDEPARTDATETIME = null;
            rowToDelete.R_DRIVER = null;
            rowToDelete.R_TRAILER = null;
            rowToDelete.SHIPPINGDATE = null;
            rowToDelete.R_FMSHIPPER = null;
            rowToDelete.R_SHIPVIA = null;
            updateData([rowToDelete], MESSAGES.DELETE_SUCCESS);
        }

        // Clear the selection after deleting the row
        rowId.current = '';
        setIsEditButtonDisabled(true);
    }
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    return (<div>
        <div className="row">
            <div className="col-md-12 main-page">
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    onHiding={hideLoadPanel}
                    visible={loadPanelVisible}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    hideOnOutsideClick={false}
                />
                <Toolbar >
                    <Item location="before">
                        <div className="title">
                            <h6
                                style={{
                                    color: window._env_.Color2
                                }}
                            >
                                OM Trips
                            </h6>
                        </div>
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={handleAddNew} text="Add" type="default" />
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={handleSubmit} text="Update OM Transaction" type="default" />
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={() => history.push('/om/transactions/delivery-management/list')} text="Back" />
                    </Item>
                </Toolbar>
                <div style={{ height: 165, marginBottom: 20, backgroundColor: "#fff" }} >
                    <FormField
                        currrentUser={currentUser}
                        layoutId='847B23EC-DA0B-4643-B8DD-EF0C2009F0CD'
                        layoutName='OMTripsForm'
                        defaultFormSchema={HeaderLayout}
                        formFields={formFields}
                        setformFields={setformFields}
                        handleFieldValueChange={handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={formRefs}
                        onFormLoad={handleFormLoad}
                        handleSelectedItemChange={handleSelectedItemChange}
                    />
                </div>
                <DataGrid
                    onExporting={(e) => {
                        if (window.handleDevExtremeDataGridExport) {
                            window.handleDevExtremeDataGridExport(e);
                        }
                    }}
                    ref={dataGrid}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    dataSource={resultData}
                    showBorders={true}
                    hoverStateEnabled={true}
                    className="GridHeightAccordianClose-tabs-with-fields"
                    onSelectionChanged={(e) => onSelectionChanged(e)}
                    remoteOperations={false}
                    searchEnabled={true}
                    columnAutoWidth={true}
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <Export enabled={true} allowExportSelectedData={true} />
                    <Selection mode="single" />
                    <Sorting visible={true} mode="multiple" />
                    <FilterPanel visible={true} />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={loadState}
                        storageKey={gridKey}
                        customSave={saveState}
                    />
                    <FilterRow visible={true} />
                    <Paging enabled={false} />
                    <Column dataField="FMPUSTOPNUMBER" caption="Stop #" dataType="string" />
                    <Column dataField="TRANSACTIONNUMBER" caption="Transaction #" dataType="string" />
                    <Column dataField="SHIPTONAME" caption="Consignee Name" dataType="string" />
                    <Column dataField="SHIPTOID" caption="Consignee" dataType="string" />
                    <Column dataField="CONSIGNEEADDRESS1" caption="Consignee Address 1" dataType="string" />
                    <Column dataField="CONSIGNEEADDRESS2" caption="Consignee Address 2" dataType="string" />
                    <Column dataField="CONSIGNEECITY" caption="Consignee City" dataType="string" />
                    <Column dataField="CONSIGNEESTATE" caption="Consignee State" dataType="string" />
                    <Column dataField="CONSIGNEEZIP" caption="Consignee Zip" dataType="string" />
                    <Column dataField="CONSIGNEECOUNTRY" caption="Consignee Country" dataType="string" />
                    <Column dataField="CONSIGNEETELEPHONE1" caption="Consignee Telephone 1" dataType="string" />
                    <Column dataField="CUSTOMERIDENTITYID" caption="Customer Code" dataType="string" />
                    <Column dataField="CUSTOMERNAME" caption="Customer Name" dataType="string" />
                    <Column dataField="SALESPERSON1" caption="Sales Person" dataType="string" />
                    <Column dataField="PURCHASEORDERNUMBER" caption="PO #" dataType="string" />

                    <Column dataField="TotalAmount" caption="Amount" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column dataField="NetWeight" caption="Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column dataField="QuantityShippedSum" caption="Volume" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column dataField="OrderedQuantity" caption="Ordered Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column dataField="ShippedQuantity" caption="Shipped Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />

                    <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="USERDEFINEDQUANTITY_1" caption="User Defined Quantity 1" />
                    <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="USERDEFINEDQUANTITY_2" caption="User Defined Quantity 2" />
                    <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="USERDEFINEDQUANTITY_3" caption="User Defined Quantity 3" />
                    <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="USERDEFINEDQUANTITY_4" caption="User Defined Quantity 4" />
                    <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="USERDEFINEDQUANTITY_5" caption="User Defined Quantity 5" />
                    <Summary>
                        <TotalItem
                            column="TotalAmount"
                            summaryType="sum"
                            valueFormat={{ type: 'fixedPoint', precision: 2, useGrouping: true }}
                            displayFormat="Amount: {0}"
                        />
                        <TotalItem
                            column="NetWeight"
                            summaryType="sum"
                            valueFormat={{ type: 'fixedPoint', precision: 2, useGrouping: true }}
                            displayFormat="Weight: {0}"
                        />
                        <TotalItem
                            column="QuantityShippedSum"
                            summaryType="sum"
                            valueFormat={{ type: 'fixedPoint', precision: 2, useGrouping: true }}
                            displayFormat="Volume: {0}"
                        />
                    </Summary>
                    <GridToolbar>
                        <GridToolbarItem location="before">
                        </GridToolbarItem>
                        <GridToolbarItem location="after">
                            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                        </GridToolbarItem>
                        <GridToolbarItem location="after">
                            <Button
                                onClick={handleDelete}
                                icon="trash"
                                disabled={!rowId.current}
                            />
                        </GridToolbarItem>
                        <GridToolbarItem name="exportButton" />
                        <GridToolbarItem name="columnChooserButton" />
                    </GridToolbar>
                </DataGrid>
            </div>
        </div>
    </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(From);